import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ebimbingan from "../../asset/ebimbingan.png";
import { PektaModal } from "../helpers/modal";
import { useLoginStore } from "../helpers/state";
import moment from "moment";
import { EyeIcon, EyeOffIcon } from "@heroicons/react/solid";

toast.configure();

let CURRENTUSER: any;

export function Login() {
  var CryptoJS = require("crypto-js");
  const { login, updateLoginField } = useLoginStore();
  const [loading, setLoading] = useState(false);
  const email = useFormInput("");
  const password = useFormInput("");
  let navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  // const [pektaAppStatus, setPektaStatus] = useState();
  // const [katamAppStatus, setKatamStatus] = useState();
  // const [pihtasAppStatus, setPihtasStatus] = useState();

  function closeModal() {
    updateLoginField("alreadyShow", "yes");
    setModalOpen(false);
  }

  const handleLogin = () => {
    setLoading(true);
    const currentTimestamp = Date.now();
    updateLoginField("lastVisited", currentTimestamp);
    axios
      .post(`${process.env.REACT_APP_AUTH_URL}/api/auth/local`, {
        identifier: email.value,
        password: password.value,
      })
      .then((response: any) => {
        if (response.data.user.confirmed === true) {
          setLoading(false);
          CURRENTUSER = response.data.user;
          let encryptjwt = CryptoJS.AES.encrypt(
            response.data.jwt,
            `${process.env.SECRET_KEY}`
          );

          updateLoginField("user", CURRENTUSER);
          updateLoginField("email", CURRENTUSER.email);
          updateLoginField("username", CURRENTUSER.username);
          updateLoginField("id", CURRENTUSER.id);
          updateLoginField("jwtToken", encryptjwt.toString());
          updateLoginField("alreadyShow", "no");

          axios
            .get(
              `${process.env.REACT_APP_API_URL}/api/users/${response.data.user.id}?populate[0]=role&populate[1]=pekta&populate[2]=pekta.pekta_applications&populate[3]=pekta.pihtas_applications`,
              {
                headers: { Authorization: `Bearer ${response.data.jwt}` },
              }
            )
            .then((response) => {
              if (response.data.role.id === 4 || response.data.role.id === 8) { // Either role PEKTA or PEKTA BARU
                updateLoginField("role", response.data.role.id);
                if (response.data.pekta === null) {
                  updateLoginField("havePekta", "no");
                  updateLoginField("pektaAppStatus", "none");
                  navigate("/myprofile");
                } else {
                  let pektaApp = response.data.pekta?.pekta_applications;
                  let pektaAppStatus =
                    response.data.pekta?.pekta_applications[pektaApp.length - 1]
                      .status;
                  updateLoginField("havePekta", "yes");
                  updateLoginField("pektaAppStatus", pektaAppStatus);
                  updateLoginField("pektaID", response.data.pekta.id);
                  navigate("/myprofile");
                }
              } else {
                window.localStorage.clear();
                navigate("/login");
                toast.error(
                  `Sila log masuk menggunakan akaun PEKTA atau daftar akaun baru. `,
                  { position: toast.POSITION.TOP_CENTER }
                );
              }
            })
            .catch((error) => {
              console.log("An error occurred:", error);
            });
        } else {
          setLoading(false);
          toast.error(`Sila log masuk kali pertama di laman e-Bimbingan.`, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(`Kata laluan yang anda masukkan adalah salah.`, {
          position: toast.POSITION.TOP_CENTER,
        });
        console.log("An error occurred:", error);
      });
  };

  const handleKeywordKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code === "Enter") {
      handleLogin();
    }
  };

  useEffect(() => {
    if (login.role) {
      navigate("/myprofile");
    }
    const fetchData = async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/pekta-setting`
      );
      updateLoginField(
        "pekta_application_enable",
        response.data.data.attributes.pekta_application_enable
      );
      updateLoginField(
        "katam_application_enable",
        response.data.data.attributes.katam_application_enable
      );
      updateLoginField(
        "pihtas_application_enable",
        response.data.data.attributes.pihtas_application_enable
      );
      updateLoginField(
        "katamEnd",
        moment(response.data.data.attributes.katam_expiry_date).format(
          "YYYY/MM/DD"
        )
      );
      updateLoginField(
        "katamStart",
        moment(response.data.data.attributes.katam_start_date).format(
          "YYYY/MM/DD"
        )
      );
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <figure className="flex justify-center items-center h-screen bg-cover md:bg-[url('/src/asset/mecca3.webp')]">
        <div className="w-full max-w-md sm:max-w-md m-auto bg-white rounded-lg border border-primaryBorder shadow-default py-6 px-4">
          <blockquote className="text-2xl font-medium text-center">
            <img src={ebimbingan} className="m-auto" alt="icon" />
          </blockquote>

          <div className="text-primary m-6">
            <div className="flex items-center mt-3 justify-center">
              <h1 className="text-2xl font-medium text-primary mt-4 mb-2">
                Log masuk ke akaun anda
              </h1>
            </div>
            <form>
              <label className="text-left">Emel atau No. PEKTA:</label>
              <input
                type={"email"}
                placeholder="Emel atau No. PEKTA"
                className="w-full p-2 text-primary border rounded-md outline-none text-sm transition duration-150 ease-in-out mb-4"
                {...email}
                autoComplete="new-password"
              />
              <label>Kata Laluan:</label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  className="w-full p-2 text-primary border rounded-md outline-none text-sm transition duration-150 ease-in-out mb-2"
                  {...password}
                  autoComplete="new-password"
                  onKeyPress={handleKeywordKeyPress}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-pressed={showPassword}
                  title={showPassword ? "Sembunyikan kata laluan" : "Tunjukkan kata laluan"}
                  className="absolute inset-y-0 right-0 flex items-center pr-3 pb-2 text-gray-500 focus:outline-none"
                >
                  {showPassword ? (
                    <EyeOffIcon className="w-5 h-5" aria-hidden="true" />
                  ) : (
                    <EyeIcon className="w-5 h-5" aria-hidden="true" />
                  )}
                </button>
              </div>
              <div className="flex items-center mt-3 justify-center">
                <input
                  className="bg-lime-700 hover:bg-green-800 py-2 px-4 text-md text-white rounded border border-blue focus:outline-none focus:border-black"
                  type="button"
                  value={loading ? "Sila tunggu sebentar..." : "Log masuk"}
                  onClick={handleLogin}
                  disabled={loading}
                />
              </div>
            </form>
            <div className="flex items-center justify-center">
              <div className="p-4 bg-gray-50 border-2 rounded-lg h-40 w-80 mt-4 sm:w-full sm:max-w-xs">
                <p className="text-gray-700 text-md font-semibold">
                  Ingin menjadi PEKTA?
                </p>
                <p className="text-gray-600 text-md">
                  Daftar menjadi pengguna untuk membuat permohonan PEKTA
                </p>
                <button
                  className="mt-3 border-2 w-72 h-11 bg-white hover:bg-gray-100 rounded-lg sm:w-full"
                  onClick={() => navigate("/register")}
                >
                  Daftar Baru
                </button>
              </div>
            </div>
          </div>
        </div>
      </figure>
      <PektaModal
        open={modalOpen}
        closeModal={closeModal}
        pekta={login.pekta_application_enable}
        katam={login.katam_application_enable}
        pihtas={login.pihtas_application_enable}
      />
    </div>
  );
}

export default CURRENTUSER;

const useFormInput = (initialValue: any) => {
  const [value, setValue] = useState(initialValue);

  const handleChange = (e: any) => {
    setValue(e.target.value);
  };
  return {
    value,
    onChange: handleChange,
  };
};
